const COMBINING_MARKS_PATTERN = /\p{M}+/gu

type SegmentResult = { segment: string }
type SegmenterLike = {
  segment: (text: string) => Iterable<SegmentResult>
}
type SegmenterConstructor = new (
  locales?: string | string[],
  options?: { granularity?: string }
) => SegmenterLike

const SegmenterCtor =
  typeof Intl !== "undefined"
    ? (Intl as unknown as { Segmenter?: SegmenterConstructor }).Segmenter
    : undefined

const greekSegmenter = SegmenterCtor
  ? new SegmenterCtor("el", { granularity: "grapheme" })
  : null

export function toNFC(text: string): string {
  return text.normalize("NFC")
}

export function splitGraphemes(text: string): string[] {
  const normalizedText = toNFC(text)

  if (greekSegmenter) {
    return Array.from(greekSegmenter.segment(normalizedText),
      (segment) => segment.segment
    )
  }

  return Array.from(normalizedText)
}

export function foldGreekForCompare(text: string): string {
  return toNFC(text)
    .normalize("NFD")
    .replace(COMBINING_MARKS_PATTERN, "")
    .normalize("NFC")
    .toLocaleLowerCase("el")
    .replace(/ς/g, "σ")
}

export function isGreekLetterLike(grapheme: string): boolean {
  const normalized = toNFC(grapheme)
  const segments = splitGraphemes(normalized)

  if (segments.length !== 1) {
    return false
  }

  return /\p{Script=Greek}/u.test(normalized)
}
